import { defineMessage } from 'services/localization';

export const messages = {
    exchangeRateText: defineMessage('basecurrency_rate_currency'),
    xeroSyncDisclaimer: defineMessage('will_be_synced_with_xer_f_there_are_differences'),
};
